import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./ServiceCard.css";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { MdStar } from "react-icons/md";
import { BeatLoader } from "react-spinners";

const ServiceCard = ({ service }) => {
  const { _id, title, price, img, description } = service;

  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    setLoading(true);
    fetch(`https://food-for-you-server.vercel.app/reviews`)
      .then((res) => res.json())
      .then((data) => {
        setReviews(data);
        setLoading(false);
      });
  }, []);

  const selectedReviews = reviews.filter((r) => r.serviceName === title);

  const arrRatingsStr = selectedReviews.map((sr) => sr.ratings);
  const arrRatingsNum = arrRatingsStr.map(Number);
  const sumRatings = arrRatingsNum.reduce(function (acc, score) {
    return acc + score;
  }, 0);

  const reviewLength = selectedReviews.length;
  let avgRatings = sumRatings / reviewLength;
  avgRatings = avgRatings.toFixed(1);

  if (isNaN(avgRatings)) {
    avgRatings = 0;
  }

  return (
    <div className="col" data-aos="zoom-in" data-aos-duration="2000">
      <div className="card service-card rounded-2 border-0 p-3 rounded-3 shadow-lg">
        <PhotoProvider
          speed={() => 800}
          easing={(type) =>
            type === 2
              ? "cubic-bezier(0.36, 0, 0.66, -0.56)"
              : "cubic-bezier(0.34, 1.56, 0.64, 1)"
          }
        >
          <PhotoView src={img}>
            <LazyLoadImage
              src={img}
              alt={title}
              className="card-img-top bg-dark rounded-3 service-img card-log"
              placeholderSrc={img}
              effect="blur"
              title="Click to see the full size photo"
              style={{ objectFit: "cover", cursor: "pointer" }}
            />
          </PhotoView>
        </PhotoProvider>
        {/* } */}

        <div className="card-body px-0 pb-0">
          <h5 className="card-title m-0 name text-start fw-bold" title="Name">
            {title}
          </h5>

          <p className="card-text mt-2" title="Short Description">
            {description.length > 110
              ? description.slice(0, 110) + "..."
              : description}
          </p>

          <div className="d-flex justify-content-between align-items-center mt-3">
            <h5
              className="fw-bold mb-0 fs-my-6 text-primary mt-1"
              title="Price"
            >
              ${price}
            </h5>

            <div>
              {loading ? (
                <div className="d-flex justify-content-center align-items-center py-1">
                  <BeatLoader color="red" size="11" speedMultiplier=".6" />
                </div>
              ) : (
                <>
                  {avgRatings === 0 ? (
                    <span className="text-danger ms-1 fs-my-0 mt-1 fw-semibold">
                      No Ratings
                    </span>
                  ) : (
                    <h5 className="fw-semibold mb-0" title="Average Ratings">
                      <div className="d-flex justify-content-center align-items-center">
                        <span className="mt-1 fs-my-5"> {avgRatings}</span>
                        <span className="mt-0">
                          <MdStar className="orange-color ms-1 fs-my-7" />
                        </span>
                      </div>
                    </h5>
                  )}
                </>
              )}
            </div>
            <div>
              <Link to={`/services/${_id}`}>
                <button className="btn btn-sm btn-outline-primary bg-gradient btn-width">
                  <span className="d-flex justify-content-between">
                    <div className="">View Details</div>
                  </span>
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
